import { AccountingApp, configureAccountingApi } from '../../modules/accounting';
import './accounting-host.css';

// Las rutas del módulo ya incluyen /api/accounting, así que la base es el servidor del API
// (REACT_APP_API_URL sin el sufijo /api). Se puede apuntar a otro servidor con REACT_APP_ACCOUNTING_URL.
const accountingBaseUrl = (process.env.REACT_APP_ACCOUNTING_URL
    ?? (process.env.REACT_APP_API_URL ?? '').replace(/\/api\/?$/, '')).replace(/\/$/, '');

// Swiftmart.API reenvía /api/accounting al API contable con el token del Wallet de la sesión;
// el navegador solo envía el JWT de Swiftmart.
configureAccountingApi({
    baseUrl: accountingBaseUrl,
    getToken: () => localStorage.getItem('token'),
    onUnauthorized: () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    },
});

// Módulo de contabilidad (menú "Contabilidad"). Usa su propio menú y rutas con hash (#/entries, #/reports...)
export const AccountingPage = () => (
    <div className="accounting-host">
        <AccountingApp />
    </div>
);
